import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../LogLoginUIHelper";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import * as columnFormatters from './column-formatters';

// ? LIBRARY TABLE PAGINATION FOR FOLDER WITHOUT PARENT UUID
const LogLoginTable = ({
  entities,
  totalCount,
  listLoading,
  queryParams = {},
  setQueryParams
}) => {
  // Table columns
  const columns = [
    {
      dataField: "user_name",
      text: "Nama",
    },
    {
      dataField: "organization_name",
      text: "Organisasi",
    },
    {
      dataField: "role",
      text: "Role",
    },
    {
      dataField: "description",
      text: "Deskripsi",
    },
    {
      dataField: "ip_address",
      text: "IP Address",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: columnFormatters.StatusColumnFormatter,
    },
    {
      dataField: "created_at",
      text: "Tangal Login",
      formatter: columnFormatters.DateColumnFormatter,
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default LogLoginTable;
